import { useRouter } from "next/router";
import classNames from "classnames/bind";
import styles from "./StaticBreadcrumbs.module.scss";
import SmartLink from "common/wrapper/SmartLink";
import { capitaliseFirstLetter } from "utils/language-helpers";

const cx = classNames.bind(styles);

export type StaticBreadcrumbsProps = {
    breadcrumbText: string;
};

export function StaticBreadcrumbs({ breadcrumbText }: StaticBreadcrumbsProps) {
    const { asPath } = useRouter();

    const breadcrumbs = asPath.replace("/", "").split("/");

    if (breadcrumbs.length < 1) return null;

    breadcrumbs.splice(-1, 1);

    const paths: string[] = [];

    breadcrumbs.forEach((b, i) => {
        if (i === 0) paths.push(b);
        else paths.push(`${paths[i - 1]}/${b}`);
    });

    return (
        <nav aria-label="Breadcrumb" className={cx("breadcrumbs")}>
            <ol className={cx("list")} itemScope itemType="https://schema.org/BreadcrumbList">
                <li
                    className={cx("listItem")}
                    itemProp="itemListElement"
                    itemScope
                    itemType="https://schema.org/ListItem"
                >
                    <SmartLink href="/">
                        <a className={cx("title", "link")} itemProp="item">
                            <span itemProp="name">Home</span>
                        </a>
                    </SmartLink>
                    <meta itemProp="position" content={String(1)} />
                </li>
                {breadcrumbs.map((b, i) => {
                    return (
                        <li
                            className={cx("listItem")}
                            itemProp="itemListElement"
                            itemScope
                            itemType="https://schema.org/ListItem"
                            key={i}
                        >
                            <SmartLink href={paths[i]}>
                                <a className={cx("title", "link")} itemProp="item">
                                    <span itemProp="name">
                                        {capitaliseFirstLetter(b.replaceAll("-", " "))}
                                    </span>
                                </a>
                            </SmartLink>
                            <meta itemProp="position" content={String(i + 2)} />
                        </li>
                    );
                })}
                <li
                    className={cx("listItem")}
                    itemProp="itemListElement"
                    itemScope
                    itemType="https://schema.org/ListItem"
                >
                    <span aria-current="page" className={cx("title", "current")}>
                        <span itemProp="name">{breadcrumbText}</span>
                    </span>
                    <meta itemProp="position" content={String(breadcrumbs.length + 2)} />
                </li>
            </ol>
        </nav>
    );
}
